/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { useCallback, useState } from "react";
import { tryCatch } from "../../utils/try-catch/try-catch.util";

/** Copy text to the clipboard. */
export const useCopyToClipboard = (): [string | null, (value: string) => Promise<boolean>] => {
  const [state, setState] = useState<string | null>(null);

  const copyToClipboard = useCallback(async (value: string) => {
    const { error } = await tryCatch(navigator.clipboard.writeText(value));

    const isSuccess = error ? await fallbackCopyToClipboard(value) : true;

    if (isSuccess) setState(value);

    return isSuccess;
  }, []);

  return [state, copyToClipboard];
};


async function fallbackCopyToClipboard(value: string): Promise<boolean> {
  const textarea = document.createElement("textarea");

  textarea.style.position = "fixed";
  textarea.style.left = "-9999px";
  textarea.style.top = "-9999px";
  textarea.style.opacity = "0";

  textarea.value = value;
  document.body.appendChild(textarea);
  textarea.select();

  const { data: isSuccess } = await tryCatch(Promise.resolve(document.execCommand("copy")));

  document.body.removeChild(textarea);

  return isSuccess ?? false;
}